/* ══════════════════════════════════════════════════════════════
   Makrontårn-bygger (mtb-): bağımsız akış, custom-macrons.js'ten
   ayrı. Config #mtb-config JSON'undan okunur. Akış:
   1 Modell → 2 Design (preset | custom) → 3 Sammendrag → cart.
   Önizleme: canlı SVG kule (renderTowerSVG).
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function boot() {
    if (!window.jQuery) { setTimeout(boot, 50); return; }
    var $ = window.jQuery;

    var cfgEl = document.getElementById('mtb-config');
    if (!cfgEl) return;
    var config;
    try { config = JSON.parse(cfgEl.textContent); } catch (e) {
      console.error('mtb: ugyldig config', e);
      return;
    }

    // ── Config normalizasyonu ─────────────────────────────────
    config.models = (config.models || []).map(function (m) {
      m.tiers = (m.tiers || []).map(function (t) { return parseInt(String(t).trim(), 10) || 0; })
                               .filter(function (n) { return n > 0; });
      return m;
    }).filter(function (m) { return m.tiers.length > 0 && m.variantId; });

    config.flavors = config.flavors || [];
    config.presets = (config.presets || []).map(function (p) {
      p.sequence = (p.sequence || []).map(function (s) { return String(s).trim(); })
                                     .filter(function (s) { return s !== ''; });
      return p;
    }).filter(function (p) { return p.sequence.length >= 1; });

    var FALLBACK = config.fallbackColor || '#d8cfc4';

    // ── State ─────────────────────────────────────────────────
    var state = {
      model: null,        // config.models[i]
      mode: null,         // 'preset' | 'custom'
      preset: null,       // config.presets[i]
      tierFlavors: [],    // alttan üste, lezzet adı | null
      activeTier: -1,
      step: 1
    };
    var _skipPush = false;

    // ── Yardımcılar ───────────────────────────────────────────
    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function findFlavor(name) {
      for (var i = 0; i < config.flavors.length; i++) {
        if (config.flavors[i].name.toLowerCase() === String(name).toLowerCase()) return config.flavors[i];
      }
      return null;
    }
    function flavorColor(name) {
      var f = name ? findFlavor(name) : null;
      return (f && f.color) ? f.color : FALLBACK;
    }
    function hexToRgb(hex) {
      var h = hex.replace('#', '');
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
    }
    function mixHex(hex, target, t) {
      var a = hexToRgb(hex), b = hexToRgb(target);
      var out = a.map(function (c, i) { return Math.round(c + (b[i] - c) * t); });
      return '#' + out.map(function (c) {
        var s = c.toString(16); return s.length === 1 ? '0' + s : s;
      }).join('');
    }
    function lighten(hex, t) { return mixHex(hex, '#ffffff', t); }
    function darken(hex, t) { return mixHex(hex, '#000000', t); }
    function luminance(hex) {
      var r = hexToRgb(hex);
      return 0.2126 * r[0] + 0.7152 * r[1] + 0.0722 * r[2];
    }
    function modelById(id) {
      for (var i = 0; i < config.models.length; i++) if (config.models[i].id === id) return config.models[i];
      return null;
    }
    function presetByName(name) {
      for (var i = 0; i < config.presets.length; i++) if (config.presets[i].name === name) return config.presets[i];
      return null;
    }
    function tierLabel(i, n) {
      if (i === 0) return 'Etasje 1 (nederst)';
      if (i === n - 1) return 'Etasje ' + n + ' (øverst)';
      return 'Etasje ' + (i + 1);
    }
    function designComplete() {
      if (!state.model || !state.mode) return false;
      if (state.tierFlavors.length !== state.model.tiers.length) return false;
      return state.tierFlavors.every(function (f) { return !!f; });
    }

    // ── Bant dağıtımı (preset + ombre ortak) ──────────────────
    // k lezzeti n etasjeye en fazla 1 fark eden bantlarla dağıtır;
    // fazlalıklar alttaki (geniş) bantlara gider.
    function distribute(list, n) {
      var k = list.length;
      if (!k || !n) return [];
      var base = Math.floor(n / k), rem = n - base * k;
      var out = [];
      for (var b = 0; b < k; b++) {
        var size = base + (b < rem ? 1 : 0);
        for (var j = 0; j < size; j++) out.push(list[b]);
      }
      return out;
    }

    // ── SVG kule ──────────────────────────────────────────────
    // Şematik önizleme: her tier tek bir yay (etasje tabağının ön kenarı),
    // makaron boyu sabit ve okunur, görünen adet gerçek adedin temsili.
    // Gerçek etasje/makaron sayısı önizleme notunda yazar.
    function renderTowerSVG() {
      var m = state.model;
      if (!m) return '';
      var VB_W = 420, VB_H = 560;
      var M_SIDE = 24, M_TOP = 30, M_BOT = 26, PLATE_H = 0; // taban tabağı kaldırıldı
      var flat = m.type === 'flat_top';
      var CAKE_H = 0; // pasta çizilmiyor, alan ayrılmaz
      var tiers = m.tiers, n = tiers.length;
      var maxCount = Math.max.apply(null, tiers);

      var availW = VB_W - 2 * M_SIDE;
      var availH = VB_H - M_TOP - M_BOT - PLATE_H - CAKE_H;

      // Alt sırada görünen makaron adedi: gerçek adede yumuşak bağlı (√ ölçek)
      var bottomVis = Math.max(3, Math.min(8, Math.round(Math.sqrt(maxCount) * 1.35)));
      // Makaron genişliği: genişlik, yükseklik ve mutlak tavanla sınırlı
      var w = Math.min(availW / (bottomVis * 1.18), availH / (1.1 * n), 64);
      var h = 0.55 * w;
      var rowStep = Math.min(availH / n, 2.0 * h);
      var arcSag = 0.45 * h;

      var towerH = (n - 1) * rowStep + h + arcSag;
      var contentH = towerH + PLATE_H + CAKE_H;
      var offset = (VB_H - M_TOP - M_BOT - contentH) / 2;

      var cx = VB_W / 2;
      var plateBottom = VB_H - M_BOT - offset;
      var plateTop = plateBottom - PLATE_H;
      var y0 = plateTop - arcSag - 0.42 * h;  // en alt sıranın merkez hattı

      var bottomRowW = bottomVis * 1.18 * w;
      // Sıra genişliği gerçek adetten değil sıra indeksinden gelir: yakın
      // adetler aynı görünür sayıya yuvarlanıp basamak yapmasın, koni düz
      // kalsın. Gerçek adetler etasje listesinde ve siparişte.
      var topRowW = flat ? Math.max(w, bottomRowW * (tiers[n - 1] / maxCount)) : w;
      function rowWAt(i) {
        return n > 1 ? bottomRowW - (bottomRowW - topRowW) * (i / (n - 1)) : bottomRowW;
      }

      var s = '<svg viewBox="0 0 ' + VB_W + ' ' + VB_H + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Forhåndsvisning av makrontårnet">';

      function macaron(x, y, c) {
        var g = '<ellipse cx="' + x + '" cy="' + (y + 0.10 * h) + '" rx="' + (0.46 * w) + '" ry="' + (0.28 * h) + '" fill="' + darken(c, 0.10) + '"/>';
        g += '<rect x="' + (x - 0.43 * w) + '" y="' + (y - 0.07 * h) + '" width="' + (0.86 * w) + '" height="' + (0.14 * h) + '" rx="2" fill="#f6efe4" opacity="0.85"/>';
        g += '<ellipse cx="' + x + '" cy="' + (y - 0.10 * h) + '" rx="' + (0.48 * w) + '" ry="' + (0.30 * h) + '" fill="' + lighten(c, 0.10) + '"/>';
        g += '<ellipse cx="' + (x - 0.18 * w) + '" cy="' + (y - 0.18 * h) + '" rx="' + (0.10 * w) + '" ry="' + (0.05 * h) + '" fill="#ffffff" opacity="0.35"/>';
        return g;
      }

      for (var i = n - 1; i >= 0; i--) {
        var count = tiers[i];
        var yRow = y0 - i * rowStep;
        var name = state.tierFlavors[i] || null;
        var c = name ? flavorColor(name) : FALLBACK;
        var gOpacity = name ? '1' : '0.35';
        var rw = rowWAt(i);
        // Aralık tavanı 1.35w: dar sıralarda makaronlar uçlara savrulup
        // ortada boşluk bırakmasın
        var vis = Math.max(1, 1 + Math.ceil((rw - w) / (1.35 * w)));
        vis = Math.min(vis, count);
        var spacing = vis > 1 ? (rw - w) / (vis - 1) : 0;

        s += '<g opacity="' + gOpacity + '">';
        // Tier yayı: etasje tabağının ön kenarı
        var arcHalf = rw / 2 + 0.30 * w;
        var yArc = yRow + 0.55 * h;
        s += '<path d="M ' + (cx - arcHalf) + ' ' + yArc + ' Q ' + cx + ' ' + (yArc + 2 * arcSag) + ' ' + (cx + arcHalf) + ' ' + yArc + '" fill="none" stroke="#cfc5b4" stroke-width="1"/>';
        // Makaronlar yayın üstüne oturur: ortadakiler önde/aşağıda
        var order = [];
        for (var j = 0; j < vis; j++) order.push(j);
        order.sort(function (a, b) {
          return Math.abs(b - (vis - 1) / 2) - Math.abs(a - (vis - 1) / 2);
        });
        for (var k = 0; k < order.length; k++) {
          var x = cx - rw / 2 + w / 2 + order[k] * spacing;
          var t = vis > 1 ? (x - cx) / (rw / 2) : 0;
          var y = yRow + arcSag * (1 - t * t);
          s += macaron(x, y, c);
        }
        s += '</g>';
      }

      // Kaketopp modelde pasta çizilmez; kesik koni (geniş düz tepe) yeterli.
      s += '</svg>';
      return s;
    }

    // ── Önizleme montajı ──────────────────────────────────────
    // Ferdige design: SVG yok, gerçek foto (yoksa placeholder).
    // Bygg selv: canlı SVG.
    function updatePreviewPanel() {
      var $ph = $('#mtb-preview-placeholder');
      if (state.mode === 'preset') {
        $('#mtb-preview-svg').hide();
        if (state.preset && state.preset.photo) {
          $ph.hide();
          $('#mtb-preview-photo').attr('src', state.preset.photo).show();
        } else {
          $('#mtb-preview-photo').hide();
          $ph.css('display', 'flex');
        }
      } else {
        $ph.hide();
        $('#mtb-preview-photo').hide();
        $('#mtb-preview-svg').show().html(renderTowerSVG());
      }
      // Not: gerçek etasje/makaron sayısını yaz
      if (state.model) {
        var noteTotal = state.model.tiers.reduce(function (a, b) { return a + b; }, 0);
        var noteHead = state.mode === 'preset'
          ? 'Tårnet får ' : 'Illustrasjonen viser farger og rekkefølge. Det ferdige tårnet får ';
        $('.mtb-preview-note').text(noteHead
          + state.model.tiers.length + ' etasjer og ' + noteTotal + ' makroner, bakt for hånd.');
      }
    }

    // ── Etasje listesi ────────────────────────────────────────
    function renderTierList() {
      if (!state.model) { $('#mtb-tiers').empty(); return; }
      var n = state.model.tiers.length;
      var html = '';
      for (var i = n - 1; i >= 0; i--) { // listede üst etasje üstte dursun
        var name = state.tierFlavors[i];
        var chip, removeBtn = '';
        if (name) {
          chip = '<span class="mtb-tier-flavor"><span class="mtb-dot" style="background:' + esc(flavorColor(name)) + '"></span>' + esc(name) + '</span>';
          removeBtn = '<span class="mtb-tier-remove" data-tier="' + i + '" role="button" tabindex="0" aria-label="Fjern smak">&times;</span>';
        } else {
          chip = '<span class="mtb-tier-flavor mtb-tier-flavor--empty">Velg smak</span>';
        }
        html += '<button type="button" class="mtb-tier-row' + (i === state.activeTier ? ' mtb-active' : '') + '" data-tier="' + i + '">'
              + '<span class="mtb-tier-label">' + tierLabel(i, n) + '</span>'
              + '<span class="mtb-tier-count">' + state.model.tiers[i] + ' stk</span>'
              + chip + removeBtn + '</button>';
      }
      $('#mtb-tiers').html(html);
    }

    function firstUnassigned(from) {
      var n = state.tierFlavors.length;
      for (var i = 0; i < n; i++) {
        var idx = (from + i) % n;
        if (!state.tierFlavors[idx]) return idx;
      }
      return -1;
    }

    function assignTier(i, name) {
      state.tierFlavors[i] = name;
      state.activeTier = firstUnassigned(i + 1);
      renderTierList();
      updatePreviewPanel();
      updateFooter();
      updateTabs();
    }

    // ── Model seçimi ──────────────────────────────────────────
    function selectModel(id) {
      var m = modelById(id);
      if (!m) return;
      var prev = state.model;
      state.model = m;
      $('.mtb-model-card').removeClass('mtb-selected').find('.mtb-model-cta').text('Velg');
      $('.mtb-model-card[data-model-id="' + id + '"]').addClass('mtb-selected')
        .find('.mtb-model-cta').text('Valgt');

      var n = m.tiers.length;
      if (state.mode === 'preset' && state.preset) {
        state.tierFlavors = distribute(state.preset.sequence, n);
      } else {
        var next = new Array(n);
        for (var i = 0; i < n; i++) next[i] = (prev && state.tierFlavors[i]) ? state.tierFlavors[i] : null;
        state.tierFlavors = next;
      }
      state.activeTier = firstUnassigned(0);
      renderTierList();
      updatePreviewPanel();
      updateFooter();
      updateTabs();
    }

    // ── Mod + preset ──────────────────────────────────────────
    function setMode(mode) {
      state.mode = mode;
      $('.mtb-mode-card').removeClass('mtb-selected');
      $('.mtb-mode-card[data-mode="' + mode + '"]').addClass('mtb-selected');
      $('#mtb-design-layout').show();
      if (mode === 'preset') {
        $('#mtb-preset-panel').show();
        $('#mtb-custom-panel').hide();
      } else {
        $('#mtb-preset-panel').hide();
        $('#mtb-custom-panel').show();
        // preset'ten custom'a geçiş: mevcut dizilim korunur, serbest düzenlenir
        state.preset = null;
        $('.mtb-preset-card').removeClass('mtb-selected');
        if (state.model && state.tierFlavors.length !== state.model.tiers.length) {
          state.tierFlavors = new Array(state.model.tiers.length).fill(null);
        }
        state.activeTier = firstUnassigned(0);
        renderTierList();
      }
      updatePreviewPanel();
      updateFooter();
      updateTabs();
    }

    function applyPreset(name) {
      var p = presetByName(name);
      if (!p || !state.model) return;
      state.preset = p;
      state.tierFlavors = distribute(p.sequence, state.model.tiers.length);
      $('.mtb-preset-card').removeClass('mtb-selected');
      $('.mtb-preset-card[data-preset-name="' + $.escapeSelector(name) + '"]').addClass('mtb-selected');
      updatePreviewPanel();
      updateFooter();
      updateTabs();
    }

    // ── Ombre ─────────────────────────────────────────────────
    var ombreSelection = [];
    function renderOmbreChips() {
      var html = '';
      config.flavors.forEach(function (f) {
        var sel = ombreSelection.indexOf(f.name) !== -1;
        html += '<button type="button" class="mtb-ombre-chip' + (sel ? ' mtb-selected' : '') + '" data-flavor="' + esc(f.name) + '">'
              + '<span class="mtb-dot" style="background:' + esc(f.color || FALLBACK) + '"></span>'
              + esc(f.name) + '</button>';
      });
      $('#mtb-ombre-chips').html(html);
      $('#mtb-ombre-apply').prop('disabled', ombreSelection.length < 2 || ombreSelection.length > 3);
    }
    function applyOmbre() {
      if (ombreSelection.length < 2 || !state.model) return;
      var sorted = ombreSelection.slice().sort(function (a, b) {
        return luminance(flavorColor(a)) - luminance(flavorColor(b)); // koyu altta
      });
      state.tierFlavors = distribute(sorted, state.model.tiers.length);
      state.activeTier = -1;
      renderTierList();
      updatePreviewPanel();
      updateFooter();
      updateTabs();
    }

    // ── Sekmeler / adımlar ────────────────────────────────────
    function stepDone(n) {
      if (n === 1) return !!state.model;
      if (n === 2) return designComplete();
      return false;
    }
    function updateTabs() {
      $('.mtb-tab').each(function () {
        var s = parseInt($(this).data('step'), 10);
        $(this).removeClass('mtb-tab--active mtb-tab--done');
        if (s === state.step) $(this).addClass('mtb-tab--active');
        else if (stepDone(s)) $(this).addClass('mtb-tab--done');
      });
    }
    function updateFooter() {
      var $back = $('#mtb-footer-back'), $next = $('#mtb-footer-next');
      $('#mtb-footer').show();
      if (state.step === 1) {
        $back.hide();
        $next.show().html('Neste &rarr;').prop('disabled', !state.model);
      } else if (state.step === 2) {
        $back.show();
        $next.show().html('Neste &rarr;').prop('disabled', !designComplete());
      } else {
        $back.show();
        $next.hide();
      }
    }
    var _booted = false;
    function showStep(n) {
      state.step = n;
      if (!_skipPush) history.pushState({ mtb: true }, '');
      $('.mtb-step').hide();
      $('#mtb-step' + n).show();
      if (n === 3) renderSummary();
      updateTabs();
      updateFooter();
      if (_booted) {
        var top = $('#mtb-tabs').offset().top;
        $('html, body').stop().animate({ scrollTop: Math.max(0, top - 90) }, 250);
      }
    }

    // ── Sammendrag ────────────────────────────────────────────
    function totalsByFlavor() {
      var order = [], counts = {};
      state.tierFlavors.forEach(function (name, i) {
        if (!name) return;
        if (!(name in counts)) { counts[name] = 0; order.push(name); }
        counts[name] += state.model.tiers[i];
      });
      return order.map(function (name) { return counts[name] + ' x ' + name; });
    }
    function formatPrice(cents) {
      var kr = Math.round(cents / 100);
      return kr.toLocaleString('nb-NO') + ',-';
    }
    function renderSummary() {
      var m = state.model;
      if (!m) return;
      var n = m.tiers.length;
      var total = m.tiers.reduce(function (a, b) { return a + b; }, 0);

      if (state.mode === 'preset') {
        if (state.preset && state.preset.photo) {
          $('#mtb-summary-preview').html('<img src="' + esc(state.preset.photo) + '" alt="' + esc(state.preset.name) + '">');
        } else {
          $('#mtb-summary-preview').html('<p class="mtb-summary-placeholder">Foto av dette designet kommer snart.</p>');
        }
      } else {
        $('#mtb-summary-preview').html(renderTowerSVG());
      }

      $('#mtb-sum-model').text(m.title + ' (' + n + ' etasjer, ' + total + ' makroner)');
      $('#mtb-sum-design').text(state.mode === 'preset' && state.preset ? 'Design: ' + state.preset.name : 'Design: Bygg selv');

      var lis = '';
      for (var i = n - 1; i >= 0; i--) {
        var name = state.tierFlavors[i] || '';
        lis += '<li><span class="mtb-dot" style="background:' + esc(flavorColor(name)) + '"></span>'
             + esc(tierLabel(i, n)) + ': ' + m.tiers[i] + ' x ' + esc(name) + '</li>';
      }
      $('#mtb-sum-tiers').html(lis);
      $('#mtb-sum-totals').text('Totalt: ' + totalsByFlavor().join(', '));
      $('#mtb-sum-price').text(formatPrice(m.price));
    }

    // ── Sepet ─────────────────────────────────────────────────
    function buildItems() {
      var m = state.model;
      var n = m.tiers.length;
      var total = m.tiers.reduce(function (a, b) { return a + b; }, 0);
      var props = {
        'Modell': m.title + ' (' + n + ' etasjer, ' + total + ' makroner)',
        'Design': (state.mode === 'preset' && state.preset) ? state.preset.name : 'Bygg selv'
      };
      for (var i = 0; i < n; i++) {
        props[tierLabel(i, n)] = m.tiers[i] + ' x ' + (state.tierFlavors[i] || '');
      }
      props['Totalt'] = totalsByFlavor().join(', ');
      if (m.type === 'flat_top' && m.plateLabel) {
        props['Plate'] = m.plateLabel + ', plass til kake på toppen';
      }
      return [{ id: m.variantId, quantity: 1, properties: props }];
    }

    var _incompleteTarget = 1;
    function validate() {
      if (!state.model) {
        return { ok: false, step: 1, msg: 'Velg tårnmodell (steg 1) før du legger i kurven.' };
      }
      if (!designComplete()) {
        return { ok: false, step: 2, msg: 'Alle etasjer må ha en smak før du kan legge tårnet i kurven.' };
      }
      return { ok: true };
    }
    function addToCart() {
      var v = validate();
      if (!v.ok) {
        _incompleteTarget = v.step;
        $('#mtb-incomplete-msg').text(v.msg);
        $('#mtb-incomplete-modal').fadeIn(200);
        return;
      }
      $('#mtb-loading').css('display', 'flex');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: buildItems() })
      })
      .then(function (res) {
        $('#mtb-loading').hide();
        if (!res.ok) throw new Error('cart/add ' + res.status);
        if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
          window.CartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        $('#mtb-loading').hide();
        console.error('mtb cart error:', err);
        window.location.href = '/cart';
      });
    }

    // ── Statik boyamalar (init) ───────────────────────────────
    // Model kartları her grup içinde fiyata göre soldan sağa artan sırada
    // (kutu builder'ındaki konvansiyon; editor blok sırasından bağımsız).
    $('.mtb-models').each(function () {
      var $wrap = $(this);
      var cards = $wrap.children('.mtb-model-card').get();
      cards.sort(function (a, b) {
        var ma = modelById(a.getAttribute('data-model-id'));
        var mb = modelById(b.getAttribute('data-model-id'));
        return ((ma && ma.price) || 0) - ((mb && mb.price) || 0);
      });
      for (var ci = 0; ci < cards.length; ci++) $wrap.append(cards[ci]);
    });

    // Palet çipleri + preset renk noktaları config'den boyanır.
    $('.mtb-chip').each(function () {
      var f = findFlavor($(this).data('flavor'));
      $(this).find('.mtb-chip-dot').css('background', (f && f.color) ? f.color : FALLBACK);
    });
    $('.mtb-preset-card').each(function () {
      var p = presetByName($(this).data('preset-name'));
      if (!p) return;
      var dots = p.sequence.slice(0, 6).map(function (name) {
        return '<span style="background:' + esc(flavorColor(name)) + '"></span>';
      }).join('');
      $(this).find('.mtb-preset-dots').html(dots);
    });

    // ── Event bağlama ─────────────────────────────────────────
    $(document).on('click', '.mtb-model-card:not(.mtb-model-card--empty)', function () {
      selectModel($(this).data('model-id'));
    });

    $(document).on('click', '.mtb-mode-card', function () {
      setMode($(this).data('mode'));
    });

    $(document).on('click', '.mtb-preset-card', function () {
      applyPreset($(this).data('preset-name'));
    });

    $(document).on('click', '.mtb-tier-row', function (e) {
      if ($(e.target).hasClass('mtb-tier-remove')) return;
      state.activeTier = parseInt($(this).data('tier'), 10);
      renderTierList();
    });

    // Etasje ataması kaldırma: satır sağındaki x
    $(document).on('click', '.mtb-tier-remove', function (e) {
      e.stopPropagation();
      var i = parseInt($(this).data('tier'), 10);
      state.tierFlavors[i] = null;
      state.activeTier = i; // palet bir sonraki tıklamada bu etasjeyi doldursun
      renderTierList();
      updatePreviewPanel();
      updateFooter();
      updateTabs();
    });

    $(document).on('click', '.mtb-chip', function (e) {
      if ($(e.target).hasClass('mtb-chip-info')) return;
      if (!state.model) return;
      var name = $(this).data('flavor');
      var target = state.activeTier >= 0 ? state.activeTier : firstUnassigned(0);
      if (target < 0) target = 0; // hepsi dolu: en alttan düzenlemeye devam
      assignTier(target, name);
    });

    // Smak info-modal
    $(document).on('click', '.mtb-chip-info', function (e) {
      e.stopPropagation();
      var $t = $(this);
      $('#mtb-info-img').attr('src', $t.data('image'));
      $('#mtb-info-name').text($t.data('name'));
      $('#mtb-info-desc').text($t.data('description') || '');
      $('#mtb-info-ingredients').text($t.data('ingredient') || '');
      $('#mtb-info-allergens').text($t.data('allergy') || '');
      $('#mtb-info-modal').fadeIn(150);
    });
    $(document).on('click', '#mtb-info-close, #mtb-info-modal .mtb-modal-overlay', function () {
      $('#mtb-info-modal').fadeOut(150);
    });

    // Ombre
    $(document).on('click', '#mtb-ombre-toggle', function () {
      $(this).toggleClass('mtb-open');
      if ($(this).hasClass('mtb-open')) {
        renderOmbreChips();
        $('#mtb-ombre-panel').slideDown(150);
      } else {
        $('#mtb-ombre-panel').slideUp(150);
      }
    });
    $(document).on('click', '.mtb-ombre-chip', function () {
      var name = $(this).data('flavor');
      var idx = ombreSelection.indexOf(name);
      if (idx !== -1) ombreSelection.splice(idx, 1);
      else if (ombreSelection.length < 3) ombreSelection.push(name);
      renderOmbreChips();
    });
    $(document).on('click', '#mtb-ombre-apply', function () {
      applyOmbre();
      $('#mtb-ombre-toggle').removeClass('mtb-open');
      $('#mtb-ombre-panel').slideUp(150);
    });

    // Navigasyon
    $(document).on('click', '#mtb-footer-next', function () {
      if (state.step === 1 && state.model) showStep(2);
      else if (state.step === 2 && designComplete()) showStep(3);
    });
    $(document).on('click', '#mtb-footer-back, .mtb-back-btn', function () {
      var t = $(this).data('target');
      showStep(t ? parseInt(t, 10) : Math.max(1, state.step - 1));
    });
    $(document).on('click', '.mtb-tab.mtb-tab--done', function () {
      showStep(parseInt($(this).data('step'), 10));
    });
    window.addEventListener('popstate', function () {
      if (state.step > 1) {
        _skipPush = true;
        showStep(state.step - 1);
        _skipPush = false;
      }
    });

    // Sepet
    $(document).on('click', '#mtb-add-btn', addToCart);
    $(document).on('click', '#mtb-incomplete-go, #mtb-incomplete-modal .mtb-modal-overlay', function () {
      $('#mtb-incomplete-modal').fadeOut(200);
      if ($(this).is('#mtb-incomplete-go')) showStep(_incompleteTarget);
    });

    // ── Başlat ────────────────────────────────────────────────
    _skipPush = true;
    showStep(1);
    _skipPush = false;
    _booted = true;
  }

  boot();
})();
